import { render, staticRenderFns } from "./addVote.vue?vue&type=template&id=d29c4a1a&scoped=true&"
import script from "./addVote.vue?vue&type=script&lang=js&"
export * from "./addVote.vue?vue&type=script&lang=js&"
import style0 from "./addVote.vue?vue&type=style&index=0&id=d29c4a1a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29c4a1a",
  null
  
)

export default component.exports